exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invest-accordion svg[data-v-6333a62a]:focus{outline:none}[data-v-6333a62a] td.exist_error{border:1px solid red}.pdfFiles[data-v-6333a62a]{padding-left:0;font-size:120%;margin-top:10px;text-transform:uppercase;font-weight:700;border-bottom:none!important}.pdfFiles .show-deleted-checkbox[data-v-6333a62a]{font-size:90%!important;text-transform:lowercase;font-weight:400}.bg-disable[data-v-6333a62a]{background:#d3d3d3}label.has-error[data-v-6333a62a]{color:#dc3545}", ""]);

// exports
